import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/layout/layout";

import "./home.css";

const HomePage = () => {
  const IllusData = [
    {
      img: "/images/Illustration1.png",
      desc: "Invest your time in scoping down what you want or need",
    },
    {
      img: "/images/Illustration2.png",
      desc: "Win time by only see relevant matches",
    },
    {
      img: "/images/Illustration3.png",
      desc: "Discuss together without middlemen",
    },
    {
      img: "/images/Illustration4.png",
      desc: "Work together on something you both want",
    },
  ];

  return (
    <Layout>
      <div className='container'>
        <div className='home-content'>
          <div className='hero-banner'>
            <div className='banner-content'>
              <h1>
                A B2B Developers Database Built From Detailed Questions & Manual
                Interviews
              </h1>
              <p>
                Chat directly. See rates in advance. See only relevant matches.
                We only show matching developers to not waste time of the
                developers and clients. Our system reveals only the developers
                if your project is a desired project of the developer.
              </p>
            </div>
            <div className='banner-btn'>
              <Link className='cta-btn' to='/developer-listing'>
                SEARCH DEVELOPER DATABASE FOR FREE
              </Link>
              <p>
                If you are a Developer <span>click here</span> !
              </p>
            </div>
          </div>
          <div className='home-illustration'>
            {IllusData.map((el, i) => (
              <div className='illustratiom-box' key={i}>
                <img src={el?.img} alt='illustration' />
                <p>{el?.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
